import React from 'react';
import Audience from '../components/audiencias/Audience';
import WebAudience from '../components/audiencias/WebAudience';
import RrssAudience from '../components/audiencias/RrssAudience';

const Audiencias = () => {
    return (
        <div >
            <Audience />
            <WebAudience />
            <RrssAudience />
        </div>
    );
};

export default Audiencias;